import { render, staticRenderFns } from "./HistoryDlg.vue?vue&type=template&id=4cfb488a&scoped=true"
import script from "./HistoryDlg.vue?vue&type=script&lang=js"
export * from "./HistoryDlg.vue?vue&type=script&lang=js"
import style0 from "./HistoryDlg.vue?vue&type=style&index=0&id=4cfb488a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb488a",
  null
  
)

export default component.exports